// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InteractionFilledSvg from "@fishx/icons-svg/es/asn/InteractionFilled";
import FishxIcon from '../components/FishxIcon';

var InteractionFilled = function InteractionFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: InteractionFilledSvg
  }));
};

InteractionFilled.displayName = 'InteractionFilled';
export default React.forwardRef(InteractionFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/InteractionFilled.js
// module id = 2989
// module chunks = 0